import { useContext, useEffect, useState } from "react";
import AssetsAllocation from "./components/assets-allocation";
import PortfolioSwiper from "./components/portfolio-swiper";
import PerformanceComponent from "./components/performance.component";
import TopHolding from "./components/top-holding";
import AssetsByCountry from "./components/assets-by-country";
import DashboardAccount from "./components/dashboard-account";
import Assets from "./components/assets.component";
import LiabilitiesComponent from "./components/liabilities.component";
import CashDistribution from "./components/cash-distribution.component";
import AccountMutualFunds from "./components/account-mutual-funds.component";
import AccountDeptInstruments from "./components/account-debt-instruments.component";
import AccountLoans from "./components/account-loans.component";
import AccountListedSecurities from "./components/account-listed-securities.component";
import AccountPrivateEquaity from "./components/account-private-equity.component";
import AccountAssetsRecivied from "./components/account-assets-recivied.component";
import AccountDeListedSecurities from "./components/account-delisted-securities.component";
import AccountTimeDeposit from "./components/account-time-deposit.component";
import AccountIslamicInstrument from "./components/account-islamic-instrument.component";
import AccountUnListedSecurities from "./components/account-unlisted-securities.component";
import AccountRealEstate from "./components/account-real-estate.component";
import AccountStateLand from "./components/account-state-land.component";
import AccountStateBuilding from "./components/account-state-building.component";
import RedemFundDetails from "./components/redem-fund-details.component";
import RedemDeptDetails from "./components/redem-dept-details.component";
import RedemTimeDeposit from "./components/redem-time-deposit.component";
import RedemIslamicInstrument from "./components/redem-islamic-instruments.component";
import RedemUnListedSecurities from "./components/redem-unlisted-securities.component";
import RedemStateLand from "./components/redem-state-land.component";
import RedemStateBuilding from "./components/redem-state-building.component";
import RedemAssetsRecevied from "./components/redem-assets-received.component";
import RedemListedSecurities from "./components/redem-listed-securities.component";
import RedemPrivateEquity from "./components/redem-private-equity.component";
import RedemDeListedSecurities from "./components/redem-delisted-securities.component";
import RedemRealEstate from "./components/redem-real-estate.component";
import RedemLoans from "./components/redem-loans.component";
import DashboardContext from "src/context/dashboard-context";
import LiabilitiesCashDistribution from "./components/liabilities-cash-distribution.component";
import AccountStructuredProducts from "./components/account-structured-products.component";
import RedemStructuredProducts from "./components/redem-structured-products.component";
import AccountHedgeFunds from "./components/account-hedge-funds.component";
import RedemHedgeDetails from "./components/redem-hedge-details.component";
import AccountPrivateMarket from "./components/account-private-market.component";
import RedemPrivateMarketDetails from "./components/redem-private-market.component";

const Dashboard: React.FC = () => {
  const {
    assets,
    liabilities,
    selectedAccount,
    assetsTotal,
    liabilitiesTotal,
    netWorth,
    portfolioList,
    selectedPortfolio,
  }: any = useContext(DashboardContext);
  const [view, setView] = useState<string>("account");
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [showCashDetails, setShowCashDetails] = useState<boolean>(false);
  const [showAssetsDetails, setShowAssetsDetails] = useState<boolean>(false);
  const [showFundDetails, setShowFundDetails] = useState<boolean>(false);
  const [selectedFund, setSelectedFund] = useState<any>();
  const [selectedKey, setSelectedKey] = useState<string>();
  const [selectedCashItem, setSelectedCashItem] = useState<any>(null);
  const [selectedCashItemCurrency, setSelectedCashItemCurrency] =
    useState<any>(null);

  useEffect(() => {
    if (selectedAccount && !selectedPortfolio) {
      setView("account");
    } else if (selectedPortfolio) {
      setView("portfolio");
    }
  }, [selectedAccount, selectedPortfolio]);

  const seeFundDetails = (fund: any) => {
    setSelectedFund(fund);
    setShowFundDetails(true);
  };

  return (
    <section className="flex flex-col w-full h-full">
      {
        <>
          {!showDetails ? (
            <div className="flex flex-wrap">
              <div className="flex flex-wrap w-full justify-between">
                <div className="flex flex-col w-full h-fit xl:w-[39.5%]">
                  <div className="flex flex-col w-full">
                    <DashboardAccount
                      view={view}
                      netWorth={netWorth as number}
                      assetsTotal={assetsTotal as number}
                      liabilitiesTotal={liabilitiesTotal as number}
                      showDetails={showDetails}
                      onDetailsClicked={() => {
                        setShowAssetsDetails(false);
                        setShowCashDetails(false);
                        setShowFundDetails(false);
                        setShowDetails(!showDetails);
                      }}
                    />
                  </div>
                  <div className="flex flex-col w-full mt-3">
                    {assets?.length ? (
                      <TopHolding assets={assets} />
                    ) : (
                      <div className="h-full w-full p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                        <div className=" text-[#2a2a2a] text-sm md:text-base font-bold ">
                          Top holdings
                        </div>
                        <div className="flex flex-col flex-grow justify-center items-center">
                          <img
                            src={"/images/empty-portfolio.svg"}
                            width={40}
                            height={40}
                            alt="Empty Performance Icon"
                          />
                          <p className="text-neutral-400 text-sm mt-3">
                            You have no holdings
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="flex flex-wrap justify-between w-full xl:w-[59.5%]">
                  {assets?.length ? (
                    <div className="w-full md:w-[35%] mt-3 xl:mt-0">
                      <AssetsAllocation assets={assets} />
                    </div>
                  ) : (
                    <div className="w-full md:w-[35%] p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                      <div className=" self-stretch text-[#2a2a2a] text-sm md:text-base font-bold">
                        Asset allocation
                      </div>
                      <div className="flex flex-col flex-grow justify-center items-center">
                        <img
                          src={"/images/empty-assets-allocation.svg"}
                          width={40}
                          height={40}
                          alt="Empty Performance Icon"
                        />
                        <p className="text-neutral-400 text-sm mt-3">
                          You have no assets yet
                        </p>
                      </div>
                    </div>
                  )}
                  <div className="flex flex-col w-full md:w-[63.5%] overflow-hidden mt-3 xl:mt-0">
                    {portfolioList?.length ? (
                      <PortfolioSwiper
                        portfolioList={portfolioList}
                        view={view}
                      />
                    ) : (
                      <div className="grow w-full p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                        <div className="w-fit opacity-90 text-[#2a2a2a] text-sm md:text-base font-bold ">
                          Portfolios
                        </div>
                        <div className="flex flex-col flex-grow justify-center items-center">
                          <img
                            src={"/images/empty-portfolio.svg"}
                            width={40}
                            height={40}
                            alt="Empty Performance Icon"
                          />
                          <p className="text-neutral-400 text-sm mt-3">
                            You have no portfolios
                          </p>
                        </div>
                      </div>
                    )}
                    {selectedAccount?.performance?.length ? (
                      <PerformanceComponent
                        performanceData={selectedAccount?.performance}
                        onDetailsClicked={() => {
                          setShowAssetsDetails(false);
                          setShowCashDetails(false);
                          setShowFundDetails(false);
                          setShowDetails(!showDetails);
                        }}
                        selectedAccount={selectedAccount}
                        selectedPortfolio={selectedPortfolio}
                      />
                    ) : (
                      <div className="h-[272px] w-full mt-3 p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                        <div className=" shrink basis-0 self-stretch opacity-70 text-[#2a2a2a] text-sm md:text-base font-bold">
                          Performance
                        </div>
                        <div className="flex flex-col flex-grow justify-center items-center">
                          <img
                            src={"/images/empty-performance-icon.svg"}
                            width={40}
                            height={40}
                            alt="Empty Performance Icon"
                          />
                          <p className="text-neutral-400 text-sm mt-3">
                            You have no performance yet
                          </p>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="flex w-full mt-3">
                    <AssetsByCountry assets={assets} />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {showDetails ? (
            <div className="flex flex-wrap">
              <div className="flex flex-wrap w-full gap-3">
                <div className="flex flex-col w-full lg:w-[49.3%] xl:w-[39.5%] ">
                  <DashboardAccount
                    view={view}
                    netWorth={netWorth as number}
                    assetsTotal={assetsTotal as number}
                    liabilitiesTotal={liabilitiesTotal as number}
                    showDetails={showDetails}
                    onDetailsClicked={() => {
                      setShowDetails(!showDetails);
                      setShowCashDetails(false);
                    }}
                  />
                  {assets?.length ? (
                    <Assets
                      selectedAccount={selectedAccount}
                      assetsData={assets}
                      setSelectedCashItem={(value: any) =>
                        setSelectedCashItem(value)
                      }
                      setSelectedCashItemCurrency={(value: any) =>
                        setSelectedCashItemCurrency(value)
                      }
                      showCashDetails={() => {
                        setShowCashDetails(true);
                        setShowAssetsDetails(false);
                      }}
                      showAssetsDetails={(keyName) => {
                        setShowFundDetails(false);
                        setShowCashDetails(false);
                        setShowAssetsDetails(true);
                        setSelectedKey(keyName);
                      }}
                    />
                  ) : (
                    <div className="h-[550px] w-full mt-3 p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                      <div className="AssetAllocation self-stretch text-[#2a2a2a] text-sm md:text-base font-bold">
                        Assets
                      </div>
                      <div className="flex flex-col flex-grow justify-center items-center">
                        <img
                          src={"/images/empty-assets-allocation.svg"}
                          width={40}
                          height={40}
                          alt="Empty Performance Icon"
                        />
                        <p className="text-neutral-400 text-sm mt-3">
                          You have no assets yet
                        </p>
                      </div>
                    </div>
                  )}
                  {liabilities?.length ? (
                    <LiabilitiesComponent
                      selectedAccount={selectedAccount}
                      liabilitiesData={liabilities}
                      setSelectedCashItem={(value: any) =>
                        setSelectedCashItem(value)
                      }
                      setSelectedCashItemCurrency={(value: any) =>
                        setSelectedCashItemCurrency(value)
                      }
                      showAssetsDetails={(keyName) => {
                        setShowFundDetails(false);
                        setShowCashDetails(false);
                        setShowAssetsDetails(true);
                        setSelectedKey(keyName);
                      }}
                    />
                  ) : (
                    <div className="h-[300px] w-full mt-3 p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                      <div className="AssetAllocation self-stretch text-[#2a2a2a] text-sm md:text-base font-bold">
                        Liabilities
                      </div>
                      <div className="flex flex-col flex-grow justify-center items-center">
                        <img
                          src={"/images/empty-assets-allocation.svg"}
                          width={40}
                          height={40}
                          alt="Empty Performance Icon"
                        />
                        <p className="text-neutral-400 text-sm mt-3">
                          You have no liabilities yet
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                {!showCashDetails && !showAssetsDetails && !showFundDetails ? (
                  <div className="flex flex-col overflow-hidden w-full lg:w-[49.3%] xl:w-[59%]">
                    {portfolioList?.length ? (
                      <PortfolioSwiper
                        portfolioList={portfolioList}
                        showDetails={showDetails}
                        view={view}
                      />
                    ) : (
                      <div className="h-fit md:h-[258px] w-full p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                        <div className="w-fit opacity-90 text-[#2a2a2a] text-sm md:text-base font-bold ">
                          Portfolios
                        </div>
                        <div className="flex flex-col flex-grow justify-center items-center">
                          <img
                            src={"/images/empty-portfolio.svg"}
                            width={40}
                            height={40}
                            alt="Empty Performance Icon"
                          />
                          <p className="text-neutral-400 text-sm mt-3">
                            You have no portfolios
                          </p>
                        </div>
                      </div>
                    )}
                    {assets?.length ? (
                      <div className="w-full">
                        <AssetsAllocation
                          assets={assets}
                          showDetails={showDetails}
                        />
                      </div>
                    ) : (
                      <div className="h-[550px] w-full mt-3 p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                        <div className="AssetAllocation self-stretch text-[#2a2a2a] text-sm md:text-base font-bold">
                          Asset allocation
                        </div>
                        <div className="flex flex-col flex-grow justify-center items-center">
                          <img
                            src={"/images/empty-assets-allocation.svg"}
                            width={40}
                            height={40}
                            alt="Empty Performance Icon"
                          />
                          <p className="text-neutral-400 text-sm mt-3">
                            You have no assets yet
                          </p>
                        </div>
                      </div>
                    )}
                    <div className="flex flex-grow mt-3">
                      {selectedAccount?.performance?.length ? (
                        <PerformanceComponent
                          performanceData={selectedAccount?.performance}
                          showDetails={showDetails}
                          selectedAccount={selectedAccount}
                          selectedPortfolio={selectedPortfolio}
                        />
                      ) : (
                        <div className="h-[300px] w-full p-4 mt-3 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                          <div className=" shrink basis-0 self-stretch opacity-70 text-[#2a2a2a] text-sm md:text-base font-bold">
                            Performance
                          </div>
                          <div className="flex flex-col flex-grow justify-center items-center">
                            <img
                              src={"/images/empty-performance-icon.svg"}
                              width={40}
                              height={40}
                              alt="Empty Performance Icon"
                            />
                            <p className="text-neutral-400 text-sm mt-3">
                              You have no performance yet
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : showCashDetails ? (
                  <div className="flex flex-col overflow-hidden w-full lg:w-[49.3%] xl:w-[59%]">
                    {assets?.length ? (
                      <CashDistribution
                        setShowCashDetails={setShowCashDetails}
                        setShowAssetsDetails={setShowAssetsDetails}
                        setShowFundDetails={setShowFundDetails}
                        selectedCashItem={selectedCashItem}
                        setSelectedCashItem={(value: any) =>
                          setSelectedCashItem(value)
                        }
                        selectedCashItemCurrency={selectedCashItemCurrency}
                        setSelectedCashItemCurrency={(value: any) =>
                          setSelectedCashItemCurrency(value)
                        }
                      />
                    ) : (
                      <div className="h-[550px] w-full mt-3 p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                        <div className="AssetAllocation self-stretch text-[#2a2a2a] text-sm md:text-base font-bold">
                          Cash
                        </div>
                        <div className="flex flex-col flex-grow justify-center items-center">
                          <img
                            src={"/images/empty-assets-allocation.svg"}
                            width={40}
                            height={40}
                            alt="Empty Performance Icon"
                          />
                          <p className="text-neutral-400 text-sm mt-3">
                            You have no cash yet
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "MUF" ? (
                  <AccountMutualFunds
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "HFD" ? (
                  <AccountHedgeFunds
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "PMT" ? (
                  <AccountPrivateMarket
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "SRP" ? (
                  <AccountStructuredProducts
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "DBT" ? (
                  <AccountDeptInstruments
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : liabilities?.length &&
                  !showFundDetails &&
                  selectedKey === "CSH" ? (
                  <div className="flex flex-col flex-grow overflow-hidden">
                    <LiabilitiesCashDistribution
                      setShowCashDetails={setShowCashDetails}
                      setShowAssetsDetails={setShowAssetsDetails}
                      setShowFundDetails={setShowFundDetails}
                      selectedCashItem={selectedCashItem}
                      setSelectedCashItem={(value: any) =>
                        setSelectedCashItem(value)
                      }
                      selectedCashItemCurrency={selectedCashItemCurrency}
                      setSelectedCashItemCurrency={(value: any) =>
                        setSelectedCashItemCurrency(value)
                      }
                    />
                  </div>
                ) : liabilities?.length &&
                  !showFundDetails &&
                  selectedKey === "LON" ? (
                  <AccountLoans
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    liabilities={liabilities}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "LEQ" ? (
                  <AccountListedSecurities
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "PEG" ? (
                  <AccountPrivateEquaity
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "AIK" ? (
                  <AccountAssetsRecivied
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "DEQ" ? (
                  <AccountDeListedSecurities
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "TDP" ? (
                  <AccountTimeDeposit
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "ISI" ? (
                  <AccountIslamicInstrument
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  (selectedKey === "UEQ" ||
                    selectedKey === "DRO" ||
                    selectedKey === "IBD" ||
                    selectedKey === "HSP" ||
                    selectedKey === "PET" ||
                    selectedKey === "DRV" ||
                    selectedKey === "OTH") ? (
                  <AccountUnListedSecurities
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    title={selectedKey}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "RES" ? (
                  <AccountRealEstate
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "REL" ? (
                  <AccountStateLand
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : assets?.length &&
                  !showFundDetails &&
                  selectedKey === "REB" ? (
                  <AccountStateBuilding
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    assets={assets}
                    view={view}
                    seeFundDetails={(fund) => seeFundDetails(fund)}
                  />
                ) : showFundDetails && selectedKey === "MUF" ? (
                  <RedemFundDetails
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "HFD" ? (
                  <RedemHedgeDetails
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "PMT" ? (
                  <RedemPrivateMarketDetails
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "SRP" ? (
                  <RedemStructuredProducts
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "DBT" ? (
                  <RedemDeptDetails
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "TDP" ? (
                  <RedemTimeDeposit
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "ISI" ? (
                  <RedemIslamicInstrument
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails &&
                  (selectedKey === "UEQ" ||
                    selectedKey === "DRO" ||
                    selectedKey === "IBD" ||
                    selectedKey === "HSP" ||
                    selectedKey === "PET" ||
                    selectedKey === "DRV" ||
                    selectedKey === "OTH") ? (
                  <RedemUnListedSecurities
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    title={selectedKey}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "REL" ? (
                  <RedemStateLand
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "REB" ? (
                  <RedemStateBuilding
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "AIK" ? (
                  <RedemAssetsRecevied
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "LEQ" ? (
                  <RedemListedSecurities
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "PEG" ? (
                  <RedemPrivateEquity
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "DEQ" ? (
                  <RedemDeListedSecurities
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "RES" ? (
                  <RedemRealEstate
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : showFundDetails && selectedKey === "LON" ? (
                  <RedemLoans
                    setShowCashDetails={setShowCashDetails}
                    setShowAssetsDetails={setShowAssetsDetails}
                    setShowFundDetails={setShowFundDetails}
                    fund={selectedFund}
                    onBackClicked={() => setShowFundDetails(false)}
                  />
                ) : (
                  <div className="h-[300px] flex-grow p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col inline-flex overflow-hidden">
                    <div className="AssetAllocation self-stretch text-[#2a2a2a] text-base font-bold">
                      Mutual funds
                    </div>
                    <div className="flex flex-col flex-grow justify-center items-center">
                      <img
                        src={"/images/empty-assets-allocation.svg"}
                        width={40}
                        height={40}
                        alt="Empty Performance Icon"
                      />
                      <p className="text-neutral-400 text-sm mt-3">
                        You have no funds yet
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            ""
          )}
        </>
      }
    </section>
  );
};

export default Dashboard;
